export const DETAILS_MODAL_ACTIONS = {
  FETCH_DETAILS_MODAL: 'Catalog::DetailsModal::SetDetailsModalFetch',
  FETCH_DETAILS_MODAL_SUCCESS: 'Catalog::DetailsModal::SetDetailsModalFetchSuccess',
  FETCH_DETAILS_MODAL_ERROR: 'Catalog::DetailsModal::SetDetailsModalFetchError',
  SET_DEVICE_IS_FAVORITE: 'Catalog::DetailsModal::SetIsFavorite',
  SET_DEVICE_IS_COMPARE: 'Catalog::DetailsModal::SetIsCompare',
  SET_DEVICE_POSITION: 'Catalog::DetailsModal::SetDevicePosition',
};
